'use strict';
module.exports = function (value) {
	if (value === 'false') {
		return false;
	}

	return Boolean(value);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/booleanify/index.js
// module id = 807
// module chunks = 0